var map = {
	"./1.png": 887,
	"./10.png": 431,
	"./11.png": 334,
	"./12.png": 101,
	"./2.png": 612,
	"./3.png": 615,
	"./4.png": 874,
	"./5.png": 419,
	"./6.png": 208,
	"./7.png": 409,
	"./8.png": 654,
	"./9.png": 439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 137;